import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import Tooltip from '../../Tooltip';
import { StyledTab, StyledSpanDisabled, StyledSpan } from './styles';
import { type TabProps } from './types';
import { TAB_CLASS_NAME } from './classnames';
const Tab = forwardRef<HTMLDivElement, TabProps>((t0, ref) => {
  const $ = _c(24);
  let adornmentPosition;
  let children;
  let disabled;
  let props;
  let tooltipProps;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      adornmentPosition,
      children,
      disabled,
      tooltipProps,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = adornmentPosition;
    $[2] = children;
    $[3] = disabled;
    $[4] = props;
    $[5] = tooltipProps;
    $[6] = value;
  } else {
    adornmentPosition = $[1];
    children = $[2];
    disabled = $[3];
    props = $[4];
    tooltipProps = $[5];
    value = $[6];
  }
  let t1;
  if ($[7] !== adornmentPosition || $[8] !== children || $[9] !== disabled || $[10] !== props || $[11] !== ref || $[12] !== value) {
    t1 = <StyledTab className={TAB_CLASS_NAME} label={children} value={value} adornmentPosition={adornmentPosition} disableFocusRipple={true} disabled={disabled} {...props} ref={ref} />;
    $[7] = adornmentPosition;
    $[8] = children;
    $[9] = disabled;
    $[10] = props;
    $[11] = ref;
    $[12] = value;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  const tab = t1;
  if (tooltipProps != null) {
    if (disabled === true) {
      let t2;
      if ($[14] !== tab) {
        t2 = <StyledSpanDisabled>{tab}</StyledSpanDisabled>;
        $[14] = tab;
        $[15] = t2;
      } else {
        t2 = $[15];
      }
      let t3;
      if ($[16] !== t2 || $[17] !== tooltipProps) {
        t3 = <Tooltip {...tooltipProps}>{t2}</Tooltip>;
        $[16] = t2;
        $[17] = tooltipProps;
        $[18] = t3;
      } else {
        t3 = $[18];
      }
      return t3;
    }
    let t2;
    if ($[19] !== tab) {
      t2 = <StyledSpan>{tab}</StyledSpan>;
      $[19] = tab;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    let t3;
    if ($[21] !== t2 || $[22] !== tooltipProps) {
      t3 = <Tooltip {...tooltipProps}>{t2}</Tooltip>;
      $[21] = t2;
      $[22] = tooltipProps;
      $[23] = t3;
    } else {
      t3 = $[23];
    }
    return t3;
  }
  return tab;
});
export default Tab;
export { Tab };